import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
@Component({
  selector: 'bll-accordion-icon-plus',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div
      [ngClass]="classNames"
      class="tw-h-full tw-left-1/2 tw--translate-x-px"
      [style.width.px]="thickness"
      [class.tw-rotate-90]="active"
      [class.tw-opacity-0]="active"
    ></div>
    <div
      [ngClass]="classNames"
      class="tw-w-full tw-top-1/2 tw--translate-y-px"
      [style.height.px]="thickness"
      [class.tw-rotate-180]="active"
    ></div>
    <ng-content></ng-content>`,
  host: {
    class: 'tw-inline-block tw-relative',
    '[class.active]': 'active',
  },
})
export class BllAccorionIconPlusComponent {
  @Input() active: boolean;
  @Output() activeChange: EventEmitter<boolean> = new EventEmitter();

  @HostBinding('style.color')
  @Input()
  color = 'var(--primary)';
  @HostBinding('style.width')
  @HostBinding('style.height')
  get _size() {
    return this.size.toString() + 'px';
  }
  @Input() size: number = 16;

  @Input() thickness: number = 2;

  classNames = 'tw-absolute tw-transform tw-transition-transform tw-bg-current tw-rounded-full';
}
